const navLinks = document.querySelectorAll(".nav-link");
const sections = document.querySelectorAll(".tab-section");

// One button = one screen. Each mode (service) has a home tab plus the
// shared history/profile tabs. The Charge SIM view renders its own
// history/profile sections under different ids.
const MODE_HOME = { ecoco: "terminal", esim: "esim-home", charge: "charge" };

const TAB_SECTIONS = {
  ecoco: {
    terminal: ["terminal-section", "list-section"],
    history: ["history-section"],
    profile: ["profile-section"],
  },
  esim: {
    "esim-home": [
      "esim-left-section",
      "esim-right-section",
      "esim-detail-section",
      "esim-actions-section",
      "esim-list-section",
    ],
    history: ["history-section"],
    profile: ["profile-section"],
  },
  charge: {
    charge: ["charge-section", "charge-list-section"],
    history: ["charge-history-section"],
    profile: ["charge-profile-section"],
  },
};

// Targets that used to be standalone tabs before the nav was reduced to
// five fixed buttons; they now live inside each mode's home screen.
const LEGACY_TARGETS = { list: "terminal", "esim-list": "esim-home", "charge-list": "charge" };

// Home targets imply their mode (used when other scripts focus a target
// belonging to a different mode than the current one).
const TARGET_MODE = { terminal: "ecoco", "esim-home": "esim", charge: "charge" };

let navMode = localStorage.getItem("navMode");
if (!MODE_HOME[navMode]) navMode = "ecoco";
let activeTab = localStorage.getItem("activeTab") || MODE_HOME[navMode];

// Drop the legacy all/focused state; the nav no longer toggles between them.
try {
  localStorage.removeItem("mobileMode");
} catch (_) {}

function isDesktop() {
  return window.innerWidth >= 768;
}

function getViews() {
  return {
    ecoco: document.getElementById("account-ecoco-view"),
    esim: document.getElementById("account-esim-view"),
    charge: document.getElementById("account-charge-view"),
  };
}

function showAllSections() {
  sections.forEach((s) => (s.style.display = "block"));
  navLinks.forEach((l) => l.classList.remove("active"));
}

function setModeVisibility(mode) {
  if (!MODE_HOME[mode]) return;
  navMode = mode;
  try {
    localStorage.setItem("navMode", mode);
  } catch (_) {}

  const views = getViews();
  Object.keys(views).forEach((key) => {
    if (views[key]) views[key].style.display = key === mode ? "" : "none";
  });

  // Keep the current service highlighted on its mode button at all times
  document.querySelectorAll(".nav-link[data-mode]").forEach((btn) => {
    btn.classList.toggle("active-mode", btn.getAttribute("data-mode") === mode);
  });

  // Sync top tab bar active state
  try {
    document.querySelectorAll(".account-tab").forEach((tab) => {
      const isActive = tab.getAttribute("data-view") === mode;
      tab.classList.toggle("active", isActive);
      tab.setAttribute("aria-selected", String(isActive));
    });
    const tabMap = { ecoco: 0, esim: 1, charge: 2 };
    const slider = document.querySelector(".account-tab-slider");
    if (slider && tabMap[mode] != null) {
      slider.style.transform = "translateX(" + tabMap[mode] * 100 + "%)";
    }
  } catch (_) {}
}

function resolveTab(target) {
  let tab = LEGACY_TARGETS[target] || target;
  if (!TAB_SECTIONS[navMode][tab]) tab = MODE_HOME[navMode];
  return tab;
}

function showTab(target) {
  let tab = LEGACY_TARGETS[target] || target;

  // Switch modes when the target belongs to another service
  const neededMode = TARGET_MODE[tab];
  if (neededMode && neededMode !== navMode) setModeVisibility(neededMode);

  tab = resolveTab(tab);
  activeTab = tab;
  try {
    localStorage.setItem("activeTab", tab);
  } catch (_) {}

  if (isDesktop()) {
    showAllSections();
    return;
  }

  const visible = new Set(TAB_SECTIONS[navMode][tab]);
  sections.forEach((s) => {
    s.style.display = visible.has(s.id) ? "block" : "none";
  });

  navLinks.forEach((l) => {
    l.classList.toggle("active", l.getAttribute("data-target") === tab);
  });
}

// Backwards-compatible API: other scripts still call
// setMobileMode('focused', target) / setMobileMode('all').
function setMobileMode(mode, target = activeTab) {
  if (isDesktop()) {
    showAllSections();
    return;
  }
  if (mode === "focused" && target) {
    showTab(target);
  } else {
    showTab(MODE_HOME[navMode]);
  }
}

window.smoothScrollToSection = function (targetId, offset = 60) {
  const el = document.getElementById(`${targetId}-section`);
  if (!el) return;
  const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: "smooth" });
};

function initializeTabs() {
  // Pages without the per-service view containers (e.g. the demo page)
  // only render ecoco sections — never start them in another mode.
  if (navMode !== "ecoco" && !getViews()[navMode]) navMode = "ecoco";
  setModeVisibility(navMode);
  if (isDesktop()) {
    showAllSections();
  } else {
    // Restore the last tab within the current mode only — never let a
    // stale tab from another mode override the mode chosen via URL/tabs.
    showTab(resolveTab(activeTab));
  }
}
window.addEventListener("DOMContentLoaded", initializeTabs);

window.addEventListener("resize", () => {
  if (isDesktop()) {
    showAllSections();
  } else {
    showTab(resolveTab(activeTab));
  }
});

// Bind click events
navLinks.forEach((link) => {
  link.addEventListener("click", () => {
    if (isDesktop()) return; // desktop: nav is hidden / ignore

    const mode = link.getAttribute("data-mode");
    const target = link.getAttribute("data-target");
    if (!target) return;

    window.closeOkawariDrawer?.();

    const sameMode = !mode || mode === navMode;
    if (sameMode && resolveTab(target) === activeTab) {
      // Re-tapping the current tab scrolls back to the top of the screen
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (mode && mode !== navMode) setModeVisibility(mode);
    showTab(target);
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
});

// expose functions/state to other scripts
window.setMobileMode = setMobileMode;
window.getMobileState = function () {
  return {
    mobileMode: isDesktop() ? "all" : "focused",
    activeTab,
  };
};
// Expose mode visibility controller so other scripts (e.g., top tabs, eSIM list) can switch modes
window.setModeVisibility = setModeVisibility;
